import React from 'react';

import { List } from 'my-containers/admin/partner';

const ListView = () => {
	return (<List/>);
}

export default ListView;